export const t4aEn = {
  'tax-documents-heading': 'Tax Documents',
  'tax-documents-no-documents-text': 'No tax documents available.',
  'tax-documents-download-button': 'Download',
  'tax-documents-download-error': 'Failed to download tax document. Please try again later.',
  'tax-documents-not-found-heading': 'Tax Document Not Available',
  'tax-documents-not-found-message': 'The T4A document for {year} is not yet available. Please check back later.',
  'tax-documents-error-heading': 'Something Went Wrong',
};

export const t4aFr = {
  'tax-documents-heading': 'Documents fiscaux',
  'tax-documents-no-documents-text': 'Aucun document fiscal disponible.',
  'tax-documents-download-button': 'Télécharger',
  'tax-documents-download-error': 'Impossible de télécharger le document fiscal. Veuillez réessayer plus tard.',
  'tax-documents-not-found-heading': 'Document fiscal non disponible',
  'tax-documents-not-found-message': 'Le document T4A pour {year} n\'est pas encore disponible. Veuillez réessayer plus tard.',
  'tax-documents-error-heading': 'Une erreur est survenue',
};
